import React from "react";

export default function Footer() {
  return (
    <div className="signature">
      <a href="https://github.com/therikay/react-unicorn-weather">
        Open Source Code{" "}
      </a>{" "}
      for 🦄 Unicorn Weather by{" "}
      <a href="https://www.linkedin.com/in/theri/"> Theri Reichlin</a>
    </div>
  );
}
